/*
* Transforms the language code to match the corresponding flag image name.
* Trims language strings with - to the last part except for chinese (zh), which is transformed to the first parth, to match the flag image naming convention.
*/
export function flagLink(language: string): string {
  let transformedLanguage: string;
  if (language.includes('-')) {
    const parts = language.split('-');
    const afterDash = parts[1];
    transformedLanguage = afterDash.length === 2
    ? afterDash.toLowerCase()
    : parts[0].toLowerCase();
  } else {
    transformedLanguage = language.toLowerCase();
  }
  return '/assets/images/flags/' + transformedLanguage + '.svg';
}